<div class="container">
  <ng-container *ngIf="(countdown$ | async) as countdown">
    <h4><span class="deadline">Order <span class="red">Deadline</span> - Make your order in:</span><span>
        {{countdown.days}} <span class="red">Days</span>
        {{countdown.hours}} <span class="red">Hours</span> {{countdown.minutes}} <span class="red">Mins</span>
        {{countdown.seconds}} <span class="red">Secs</span></span></h4>
    <p>TO RECEIVE YOUR ORDER NO LATER THAN {{delivery_deadline | date: 'dd/MM/yy'}}</p>
  </ng-container>
</div>
